export const NEW_COVERAGES = "newProducts";

export const PROSPECT_COVERAGES = "prospectCoverages";

export const EN_CENSUS_AVAILABLE_VALUES = {
  YES: "yes",
  NO: "no",
} as const;

export const EN_PUSH_SOLD_PLAN_DATA_VALUES = {
  YES: "yes",
  NO: "no",
} as const;

const STATE_COVERAGE_OPTIONS = {
  SDI: "State Disability Insurance (SDI)",
  PFL: "Paid Family Leave (PFL)",
  PFML: "Paid Family Medical Leave (PFML)",
  PFMLI: "Paid Family and Medical Leave Insurance (PFMLI)",
  PFMLA: "Paid Family Medical Leave Act (PFMLA)",
  DBL: "Disability Benefits Leave (DBL)",
  DBA: "Disability Benefits Act (DBA)",
  UPL: "Universal Paid Leave (UPL)",
  TDI: "Temporary Disability Insurance (TDI)",
  TDB: "Temporary Disability Benefits (TDB)",
  TCI: "Temporary Caregiver Insurance (TCI)",
  FLI: "Paid Family Leave Insurance (FLI)",
};

const { SDI, PFL, PFML, PFMLI, PFMLA, DBL, DBA, TDI, TDB, FLI } =
  STATE_COVERAGE_OPTIONS;

export const STATE_OPTIONS = {
  California: [SDI, PFL],
  Colorado: [PFML],
  Connecticut: [PFML],
  Delaware: [PFML],
  Hawaii: [TDI],
  Maine: [PFML],
  Massachusetts: [PFML],
  Maryland: [PFMLI],
  Minnesota: [PFML],
  "New Hampshire": [PFMLA],
  "New Jersey": [TDB, FLI],
  "New York": [DBL, PFL],
  Oregon: [PFMLI],
  "Puerto Rico": [DBA],
  "Washington State": [PFML],
};

export const RFP_ACTION_TYPES = {
  UPDATE_STILL_PENDING_DOC: "updateStillPending",
  UPDATE_COVERAGES: "updateCoverages",
  UPDATE_NEXT_STEP: "updateNextStep",
  UPDATE_STEP: "updateStep",
  UPDATE_BACK_STEP: "updateBackStep",
  UPDATE_SELECTED_COVERAGES: "updateSelectedCoverages",
  UPDATE_SELECTED_CARRIERS: "updateSelectedCarriers",
  UPDATE_CENTRO_SELECTED_CARRIER: "updateCentroSelectedCarrier",
  UPDATE_DOCUMENT: "updateDocuments",
  SET_DOCUMENTS: "setDocuments",
  PREPARE_RFP: "prepareRfp",
  UPDATE_COVERAGE_INDEX: "updateCoverageIndex",
  HANDLE_BACK_COVERAGE: "handleBackCoverage",
  HANDLE_NEXT_VALIDATE_COVERAGE: "handleNextValidateCoverage",
  UPDATE_SELECTED_COVERAGE_WITH_DOCUMENTS:
    "updateSelectedCoveragesWithDocuments",
  UPDATE_LAST_MODIFIED: "updateLastModified",
  UPDATE_RFP_ID: "updateRfpId",
  CLEANUP_DOCUMENTS: "cleanupDocuments",
  UPDATE_FIELD: "updateField",
  UPDATE_STATE_RELATED_DOCUMENTS: "updateStateRelatedDocuments",
  UPDATE_STATE_UPLOAD_DOCUMENTS_WITHOUT_COVERAGE:
    "updateStateUploadDocumentsWithoutCoverage",
  UPDATE_STATE_DELETE_DOCUMENT: "updateStateDeleteDocument",
  UPDATE_DOCUMENT_TYPES: "updateDocumentTypes",
  UPDATE_ADDITIONAL_DOCUMENTS: "updateAdditionalDocuments",
  REMOVE_ADDITIONAL_DOCUMENTS: "removeAdditionalDocuments",
  EDIT_STATE_RELATED_DOCUMENTS: "editStateRelatedDocuments",
  REMOVE_STATE_RELATED_DOCUMENTS: "removeStateRelatedDocuments",
  REMOVE_STATE_RELATED_DOCUMENTS_ALL_COVERAGES:
    "removeStateRelatedDocumentsAllCoverages",
};

export const CLIENT_TYPES = {
  CURRENT_CLIENT: "current_client",
  NEW_CLIENT: "new_client",
  PROSPECT_CLIENT: "prospect_client",
};

export const RFP_STEPS = {
  RFP_FORM: 0,
  SELECTED_COVERAGES: 1,
  COVERAGE_FORMS: 2,
  SELECTED_CARRIERS: 3,
  DOCUMENTS: 4,
  SUMMARY: 5,
};

export const VICEVERSA_RFP_STEPS = {
  "RFP details": 0,
  "Quote Coverages": 1,
  "Coverage Details": 2,
  Carriers: 3,
  Documents: 4,
  Review: 5,
};

export const RFP_ORIGIN_FLOW = {
  DRAFT: "draft flow",
  CLIENT: "client selection",
};

export const DUE_DATE_ALERT_STATUS = {
  WARNING: "warning",
  ERROR: "error",
};

export const REQUESTED_SYSTEMS = [
  { value: "employeeNavigator", label: "EmployeeNavigator" },
  { value: "ease", label: "Ease" },
  { value: "bSwift", label: "bSwift" },
  { value: "adp", label: "ADP" },
  { value: "planSource", label: "PlanSource" },
  { value: "paychex", label: "Paychex" },
  { value: "triNet", label: "TriNet" },
  { value: "rippling", label: "Rippling" },
  { value: "paylocity", label: "Paylocity" },
  { value: "selerix", label: "Selerix" },
  { value: "zenefits", label: "Zenefits" },
  { value: "workday", label: "Workday" },
  { value: "paycom", label: "Paycom" },
  { value: "other", label: "Other" },
];
